import { Currency, SystemOfUnits } from '@trumpf-xguide/xguide';

export const SHARED_SETTINGS_NAMESPACE = 'shared';
export const DEFAULT_APP_SETTINGS = {
  unitSystem: SystemOfUnits.Metric,
  currency: Currency.Euro,
};
